import api from '@pray/shared/utils/api';

import type { RecurringEventListResponse, RecurringEventType } from './types';

// GET …/campaigns/recurring/:id/events — the series' event feed, newest first.
export async function getRecurringCampaignEvents({
  artistId,
  recurringCampaignId,
  limit,
  offset,
  type,
}: {
  artistId: string;
  recurringCampaignId: string;
  limit?: number;
  offset?: number;
  type?: RecurringEventType;
}): Promise<RecurringEventListResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const params: Record<string, string | number> = {};
  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;
  if (type) params.type = type;

  const url = `/web/studio/artists/${artistId}/campaigns/recurring/${recurringCampaignId}/events`;
  const response = await api.executeGetRequest<{ data: RecurringEventListResponse }>(url, params);
  return response.data.data;
}
